import { useState } from "react";

import { fetchTransactionDetails } from "apis/order";

import { showError } from "@stadium/services/react-toastify";

export const useFetchTransactionDetails = () => {
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [transactionData, setTransactionData] = useState({});

  const getTransactionDetails = (orderNumber) => {
    setLoading(true);
    fetchTransactionDetails(orderNumber)
      .then((transaction) => {
        setTransactionData(transaction);
      })
      .catch((err) => {
        setHasError(true);
        err?.response?.data?.errors?.map(({ detail }) => showError(detail));
      })
      .finally(() => setLoading(false));
  };

  return {
    getTransactionDetails,
    transactionDataLoading: loading,
    transactionData,
    hasError,
  };
};
